import React, { useContext, useEffect, useState } from 'react';
import ProjectContainer from '../../components/containers/ProjectContainer';
import { Components } from './styled';
import ProjectTableHeader from '../../components/ProjectTableHeader';
import useFormTextState from '../../hooks/useFormTextState';
import ProjectTable from '../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../hooks/useModalState';
import { UserPath } from '../../api/types/userPath';
import { deleteUserPath, getAllUserPaths } from '../../api/userPath';
import CreateOrEditUserPathModal from '../../components/modals/CreateOrEditUserPathModal';

const UserPaths = () => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<UserPath[]>([]);

  const searchProps = useFormTextState();

  const createUserPathModalProps = useModalState<{ userPath?: UserPath }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllUserPaths();
    setIsLoading(false);

    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddUserPath = () => {
    createUserPathModalProps.open({});
  };

  const onEditUserPath = (id: string) => {
    const userPath = data?.find((item) => item?.id === id);

    if (userPath) {
      createUserPathModalProps.open({ userPath });
    }
  };

  const onDeleteUserPath = async (id: string) => {
    setIsLoading(true);
    await deleteUserPath(id);
    setIsLoading(false);
    await refreshData();
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
    }

    createUserPathModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'title', value: searchProps.value, operatorValue: 'contains' },
  ]);

  return (
    <ProjectContainer title={'User Paths'}>
      <Components.Container>
        <ProjectTableHeader
          onSearchChange={searchProps.onChangeText}
          searchLabel={'Search by title or ID'}
          searchPlaceholder={'Enter search term'}>
          <Components.SearchBarSeparator />
          <Components.PrimaryButton onClick={onAddUserPath}>Add User Path</Components.PrimaryButton>
        </ProjectTableHeader>
        <Components.TableWrapper>
          <ProjectTable
            data={data || []}
            columns={tableColumns.userPaths({ onEdit: onEditUserPath, onDelete: onDeleteUserPath })}
            filteringModel={_filteringModel}
            sortingModel={{ field: 'title', sort: 'asc' }}
          />
        </Components.TableWrapper>
      </Components.Container>
      <CreateOrEditUserPathModal
        {...createUserPathModalProps}
        onModalClose={onCreateOrEditModalClose}
        refreshCallback={refreshData}
      />
    </ProjectContainer>
  );
};

export default UserPaths;
